module.exports = __webpack_public_path__ + "fonts/opensans-bold.54f5fbbb6bc75052bae0.ttf";